import dayjs from "dayjs";
import { padStart } from "lodash";

/**
 * @param duration the duration in ms
 * @returns {string} the 0 padded string representation of minutes for given duration, example: '02'
 */
export function formatMinutes(
  duration: number,
  options: { noPaddingBelow10: boolean } = { noPaddingBelow10: false }
): string {
  const minutes = dayjs.duration(duration).minutes();
  const padding = options.noPaddingBelow10 ? (minutes > 10 ? 2 : 1) : 2;
  return padStart(minutes + "", padding, "0");
}

/**
 * @param duration the duration in ms
 * @returns {string} the 0 padded string representation of seconds for given duration, example: '02'
 */
export function formatSeconds(duration: number): string {
  const seconds = dayjs.duration(duration).seconds();
  return padStart(seconds + "", 2, "0");
}

/**
 *
 * @param duration the duration in ms
 * @returns {string} minute:seconds string representation of time for given duration, example: '02:59'
 */
export function formatTime(
  duration: number,
  options: { noPaddingBelow10: boolean } = { noPaddingBelow10: false }
): string {
  return `${formatMinutes(duration, options)}:${formatSeconds(duration)}`;
}
